import React, {FC, useState} from 'react';

import {InboxesPanelId} from '../../store/panels/panelStateBase';
import {AppFrame} from '../app/appFrame';
import {InboxesContainer} from './inboxesContainer';

/*
 * Props.
 */

interface InboxesFrameProps {
  panelId: InboxesPanelId;
  isVisible: boolean;
}

/*
 * Component.
 */

export const InboxesFrame: FC<InboxesFrameProps> = (props) => {
  const {panelId, isVisible} = props;
  const [hasVisited, setHasVisited] = useState(false);

  // Render when the user has visited the route once.
  if (isVisible && !hasVisited) {
    setHasVisited(true);
  }

  if (!hasVisited) {
    return null;
  }

  return (
    <AppFrame isVisible={isVisible}>
      <InboxesContainer panelId={panelId} />
    </AppFrame>
  );
};
